
/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */

// 倒计时
function getRandomNum(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}
  new Swiper("#swiper-btn", {
    direction: 'vertical',
        autoplay: true,
        autoplay: {
          disableOnInteraction: false,
        },
        loop: true,

        spaceBetween: 30,
      });
let endTimeG;

function cutDownTime() {
  let nowTime = new Date();
  let endTime = new Date(endTimeG);

  let leftTime = endTime.getTime() - nowTime.getTime();
  if (leftTime < 0) {
    setupNewCountdown();
    leftTime = 0;
  }
  let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
    leftM = Math.floor((leftTime / (1000 * 60)) % 60),
    leftS = Math.floor((leftTime / 1000) % 60);
  leftH = leftH >= 10 ? leftH : "0" + leftH;
  leftM = leftM >= 10 ? leftM : "0" + leftM;
  leftS = leftS >= 10 ? leftS : "0" + leftS;

  return {
    hour: leftH,
    minute: leftM,
    second: leftS,
  };
}
function setupNewCountdown() {
  const randomHour = getRandomNum(1, 9);
  const currentTime = new Date();
  endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
}
let intervalId;

function getCutDownTime() {
  setupNewCountdown();
  if (intervalId) clearInterval(intervalId);
  intervalId = setInterval(function () {
    let cutDownTimeText = cutDownTime();
    $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
    $(".sp_top_cut_down .sp_left_view .sp_minute").html(cutDownTimeText.minute);
    $(".sp_top_cut_down .sp_left_view .sp_second").html(cutDownTimeText.second);
  }, 1000);
}

    // style选项
    let typeOptions = $('#sp-type .option')
 let spImgList = [ // Without display 1 当type==  Without display && 数量为1 
         "https://cdn.shopify.com/s/files/1/0752/2946/2806/files/20240923-p1.png",
    "https://cdn.shopify.com/s/files/1/0752/2946/2806/files/20240923-p4.png",
      "https://cdn.shopify.com/s/files/1/0752/2946/2806/files/20240923-p3.png",
     "https://cdn.shopify.com/s/files/1/0752/2946/2806/files/20240923-p2.png",
   "https://cdn.shopify.com/s/files/1/0596/0050/2882/files/20240921-p4.png",
  "https://cdn.shopify.com/s/files/1/0596/0050/2882/files/20240921-p5.png",
  "https://cdn.shopify.com/s/files/1/0596/0050/2882/files/20240921-p6.png"
    ];
  
 
let spImgList2 = [ //With display 2
     "https://cdn.shopify.com/s/files/1/0752/2946/2806/files/20240923-with1-1.png",
     "https://cdn.shopify.com/s/files/1/0752/2946/2806/files/20240923-with1-4.png",
      "https://cdn.shopify.com/s/files/1/0752/2946/2806/files/20240923-with1-3.png",
   "https://cdn.shopify.com/s/files/1/0752/2946/2806/files/20240923-with1-2.png",
   "https://cdn.shopify.com/s/files/1/0596/0050/2882/files/2_9cd83374-057c-444c-8c07-1fd574f6decb.png",
        "https://cdn.shopify.com/s/files/1/0752/2946/2806/files/20240923-with2-4.png",
      "https://cdn.shopify.com/s/files/1/0752/2946/2806/files/20240923-with2-3.png",
    ];

    

    typeOptions.click(function () {
      $(this).addClass('active').siblings().removeClass('active')
      changeChose()
    })
    $('#sp-color .option').click(function () {
      $(this).addClass('active').siblings().removeClass('active')
      changeChose()
    })
    function changeChose() {
      var index = $('#sp-type .option.active').index()
      var index2 = $('#sp-color .option.active').index()
      if(index == 0) {
           $('.product-part .p-img').attr('src', spImgList[index2])
          // console.log(spImgList2[index2])
        } else {
           $('.product-part .p-img').attr('src', spImgList2[index2])
      }
       if(index2 > 3){
    $('.product-part .sp-free').css('display', 'block')
  }else{
    $('.product-part .sp-free').css('display', 'none')
  }
    }
getCutDownTime();

   let prods = window.product
        function getCur(){
        let type = $('#sp-type div.active').attr('data-val')
             let color = $('#sp-color div.active').attr('data-val')
          return prods.filter(item=> item.option1 == type && item.option2 == color)[0]
        }
        function changePrice(){
          let num = $('#calcNumber').val()
          let price = (getCur().price * num / 100).toFixed(2)
          let compare = (getCur().compare_at_price * num / 100).toFixed(2)
          $('#sp_price1').html(price)
          $('#sp_price2').html(compare)
           let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
          $(".product-part .sp-brand span").html(off_font); 
        }

      $('.sp-btn-style').click(function(){
          let num = $('#calcNumber').val()
          window.location.href = '/cart/' + getCur().id + ':' + num
        })


$(".reduce").click(function () {
  let input = $(this).siblings("input")[0];
  let num = Number(input.value) - 1;
  if (num > 0) {
    input.value = num;
    // changePrice()
  }
});
$(".add").click(function () {
  let input = $(this).siblings("input")[0];
  let num = Number(input.value) + 1;
  input.value = num;
 // changePrice()
});
$(".option").click(function () {
  $(this).siblings().removeClass("active");
  $(this).addClass("active");
  // style选项
  // let colorOptions = $("#sp-color .option.active").index();
  // $(".product-part .p-img")[0].src = spImgList[colorOptions];
  // if(colorOptions >=3){
  //   $('.product-part .sp-free').css('display', 'block')
  // }else{
  //   $('.product-part .sp-free').css('display', 'none')
  // }
  changePrice()
});

// let spImgList = [];

function mainRender() {
  $(function () {
    $("#root").css("zoom", "normal");
    let scale = document.body.clientWidth / 1080;
    $("#root").css("zoom", scale);

    window.addEventListener(
      "resize",
      (function () {
        var timer;
        return function () {
          if (timer) clearTimeout(timer);
          timer = setTimeout(function () {
            $("#root").css("zoom", "normal");
            let scale = document.body.clientWidth / 1080;
            $("#root").css("zoom", scale);
          }, 100);
        };
      })()
    );
  });

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
    const config = {
      rootMargin: "0px 0px 1300px 0px",
      threshold: 0,
    };

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target;
          const dataSrc = image.getAttribute("data-src");
          image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image); // 停止观察该图片
        }
      });
    },
    config);

    images.forEach(function (image) {
      lazyLoadObserver.observe(image); // 开始观察每个图片
    });
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      });
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    lazyLoadImages();

    preloadImages(spImgList);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            185 * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });
  });

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  var isAndroid = /android/i.test(userAgent);
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log("Android");
  } else if (isIOS) {
    console.log("iOS");
  } else if (isPC) {
    console.log("PC");
  } else {
    $(".sp_system").css("letter-spacing", "-4px");
  }

 
}

mainRender();
